export default "__VITE_ASSET__BlqntUJR__"